class anchor {
  _constructor() {
    this.$anchors = document.getElementsByClassName('anchor')
    this.$mainMenu = document.querySelector('.main-header')
  }

  _moveTo(section) {
    let $section = document.querySelector(section)
    if( $section !== null) {
      let t = $section.offsetTop
      let h = this.$mainMenu.offsetHeight

      $('html, body').animate({
        scrollTop: t - h
      }, 250)
    }
  }

  init() {
    this._constructor()
    const self = this

    for(let $link of self.$anchors) {
      $link.addEventListener('click', function(event) {
        event.preventDefault()
        self._moveTo( this.getAttribute('href') )
      })
    }
  }
}
export default anchor
